import FeatureGates, { GetExperimentOptions, DynamicConfig } from '@atlaskit/feature-gate-js-client';

export const useExperiment = (name: string, options?: GetExperimentOptions): DynamicConfig | undefined => {
  return FeatureGates.getExperiment(name, options);
};
